<template>
    <div class="product-extra" v-if="!deleted">
        <b-form-group label="Cost Price">
            <b-input-group>
                <b-input-group-addon>&pound;</b-input-group-addon>
                <b-form-input v-model="extra.costPrice"></b-form-input>
            </b-input-group>
        </b-form-group>

        <b-row>
            <b-col cols="6">
                <b-form-group label="Maximum Quantity">
                    <b-form-input v-model="extra.maxQty" type="number"></b-form-input>
                </b-form-group>
            </b-col>

            <b-col cols="6">
                <b-form-group label="Available To">
                    <b-form-select v-model="extra.availableTo" :options="['all', 'gbc']"></b-form-select>
                </b-form-group>
            </b-col>
        </b-row>

        <hr />

        <h5 class="mb-2">International Pricing</h5>

        <div v-for="country in countries">
            <b-form-group>
                <b-row>
                    <b-col cols="2" class="text-right">
                        {{ country.label }}
                    </b-col>

                    <b-col cols="6">
                        <b-input-group>
                            <b-form-input v-model="extra.pricing[country.label]"></b-form-input>
                            <b-input-group-addon>{{ country.currency }}</b-input-group-addon>
                        </b-input-group>
                    </b-col>

                    <b-col cols="4">
                        <b-input-group v-if="country.label === 'UK'">
                            <b-form-checkbox v-model="extra.pricingInSSP[country.label]" value="1" unchecked-value="0">Include in SSP?</b-form-checkbox>
                        </b-input-group>
                    </b-col>
                </b-row>
            </b-form-group>
        </div>

        <b-button variant="danger" v-on:click="deleteExtra()" v-if="!extra._new">Delete</b-button>

        <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
    </div>
</template>

<script>
  import Simplert from 'vue2-simplert'
  import { fb } from '../firebase'

  export default {
    name: 'productExtra',
    props: ['extra', 'product'],
    firebase () {
      return {
        extras: {
          source: fb.database().ref('extras')
        },
        countries: {
          source: fb.database().ref('countries')
        }
      }
    },
    data () {
      return {
        deleted: false
      }
    },
    components: {
      Simplert
    },
    methods: {
      deleteExtra () {
        for (let i = 0; i < this.product.extras.length; i++) {
          if (this.product.extras[i].extra === this.extra.extra) {
            this.product.extras.splice(i, 1)
          }
        }
        fb.database().ref('products/' + this.product['.key'] + '/extras').set(this.product.extras).then(() => {
          this.$refs.simplert.openSimplert({
            title: 'Deleted',
            type: 'info',
            message: 'The optional extra has been deleted.'
          })
          this.deleted = true
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/ProductExtra.vue